import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { avatarTone, initials } from '@/lib/clinic/format'

type AvatarSize = 'sm' | 'md' | 'lg' | 'xl'

interface PatientAvatarProps {
    name: string
    seed: string
    size?: AvatarSize
    className?: string
}

const SIZES: Record<AvatarSize, string> = {
    sm: 'size-8 text-xs',
    md: 'size-10 text-sm',
    lg: 'size-12 text-base',
    xl: 'size-16 text-xl'
}

const PatientAvatar: FC<PatientAvatarProps> = ({ name, seed, size = 'md', className }): ReactNode => {
    return (
        <span
            aria-hidden='true'
            className={cn(
                'inline-flex shrink-0 items-center justify-center rounded-full font-semibold tracking-wide',
                avatarTone(seed),
                SIZES[size],
                className
            )}
        >
            {initials(name)}
        </span>
    )
}

export default PatientAvatar
